<template>
  <PbDialog
    dialog-title="Release notes"
    class="pb-release-notes-dialog"
    :state="state"
    @open="open"
    @close="close"
  >
    <div class="txt-rich">
      <h3>November 2026 - v2.7</h3>
      <ul>
        <li>
          Added beam clusters
        </li>
        <li>Bug fixes</li>
      </ul>
      <h3>May 2026 - v2.6</h3>
      <ul>
        <li>
          Added the "luminous flux" profile property
        </li>
        <li>Bug fixes and minor UI/UX improvements</li>
      </ul>
      <h3>November 2025 - v2.5</h3>
      <ul>
        <li>
          New form to request creation of profiles to our support,
          directly from Profile&nbsp;Builder
        </li>
        <li>Ability to report profiles that do not work as expected to our support</li>
        <li>
          Added an "extended" view in presets selection.
          It can be enabled and disabled for each preset category, and is
          enabled by default for gobos
        </li>
      </ul>
      <h3>March 2024 - v2.3</h3>
      <ul>
        <li>Modes can now be named &amp; reordered</li>
        <li>Various user experience &amp; accessibility improvements</li>
        <li>Bug fixes</li>
      </ul>
      <h3>February 2024 - v2.1</h3>
      <ul>
        <li>3D model preview is back</li>
        <li>Performance improvements</li>
        <li>Bug fixes</li>
      </ul>
      <h3>September 2023 - v2.0</h3>
      <ul>
        <li>
          The preset ranges from ScanLibrary are back !
          (you can create and edit them for now, master channel selection will come later)
        </li>
        <li>Keyboard shortcuts (Enter/Escape/Backspace for now, more to come later)</li>
        <li>
          Global channels are now replaced by template channels:
          channels and presets will stay synchronized across modes when editing the template channel
        </li>
        <li>Improved presets categorization and filtering</li>
        <li>New supported LEE & Rosco color filters</li>
        <li>Ability to save and reuse favorite colors</li>
        <li>Better error reporting</li>
        <li>Lots of accessibility, stability and usability improvements</li>
        <li>Simplified and cleaned UI</li>
        <li>Many bugfixes</li>
      </ul>
    </div>
  </PbDialog>
</template>

<script setup>
import PbDialog from '@/components/PbDialog.vue'

defineProps({
  state: { type: Boolean, default: true },
})

const emit = defineEmits(['open', 'close'])

function close() {
  // When the close button or the overlay of the dialog is clicked or escape is pressed
  emit('close')
}

function open() {
  // When the dialog is opened
  emit('open')
}
</script>
